import { useEffect } from 'react';
import { useRouter } from 'next/router';
import Script from 'next/script';

import { SitecoreContextValue } from 'src/lib/ComponentProps';

import { SeoMetaData } from 'src/types/SeoMetaData';

type GTVirtualPageViewProps = {
	sitecoreContext: SitecoreContextValue;
	wildcardMetaData?: SeoMetaData;
};

export default function GTVirtualPageView(props: GTVirtualPageViewProps): JSX.Element {
	const router = useRouter();
	const pageUrl = props.sitecoreContext.host + router.asPath;
	const pageTitle = props.sitecoreContext.wildcardMetaData
		? props.wildcardMetaData?.pageTitle
		: props.sitecoreContext.route.fields?.PageTitle?.value;

	const dataLayer = `
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      'event': 'virtualPageview',
      'pageUrl': '${pageUrl ? pageUrl : ''}',
      'pageTitle': '${pageTitle ? pageTitle : ''}',
    });
  `;

	useEffect(() => {
		const googleAnalyticsTags = document.getElementById('virtual-page-view');

		googleAnalyticsTags?.replaceChildren(dataLayer);
	}, [dataLayer]);

	return (
		<Script id="virtual-page-view" strategy="afterInteractive">
			{dataLayer}
		</Script>
	);
}
